import React, { useEffect, useState } from "react";
import "../styles.css";

type CoachMarkStepFourProps = {
  visible: boolean;
  onNext: () => void;
  targetSelector?: string;
};

const MAX_CARD_WIDTH = 430;

const CoachMarkStepFour = ({
  visible,
  onNext,
  targetSelector = ".coach-view-prize",
}: CoachMarkStepFourProps) => {
  const [position, setPosition] = useState({ top: 120, left: 12 });

  useEffect(() => {
    if (!visible) return;

    const updatePosition = () => {
      const target = document.querySelector(targetSelector) as HTMLElement | null;

      if (!target) {
        setPosition({ top: 120, left: 0 });
        return;
      }

      const rect = target.getBoundingClientRect();
      const effectiveCardWidth = Math.min(MAX_CARD_WIDTH, window.innerWidth - 24);
      const desiredTop = rect.bottom + 8;
      const maxTop = Math.max(12, window.innerHeight - 220);
      const desiredLeft = rect.left;
      const maxLeft = Math.max(0, window.innerWidth);

      setPosition({
        top: Math.max(12, Math.min(desiredTop, maxTop)),
        left: Math.max(12, Math.min(desiredLeft, maxLeft)),
      });
    };

    updatePosition();
    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true);

    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
    };
  }, [targetSelector, visible]);

  if (!visible) return null;

  return (
    <div
      className="coachmark-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Coach mark step four"
    >
      <div
        className="coachmark-step-four-card"
        style={{ top: `${position.top}px`, left: `${position.left - 180}px` }}
      >
        <div className="coachmark-step-four-content">
          <img
            src={require("../../assets/coachViewBlackLogo.png")}
            alt=""
            aria-hidden="true"
            className="coachmark-step-four-logo"
          />
          <div className="coachmark-step-four-text-wrap">
            <div className="coachmark-step-four-text">Your points can be</div>
            <div className="coachmark-step-four-text">redeemed for</div>
            <div className="coachmark-step-four-text">
              <span className="coachmark-step-four-prizes">prizes!</span>
            </div>
          </div>
        </div>

        <button
          type="button"
          onClick={onNext}
          className="coachmark-step-four-next"
          aria-label="Finish coach mark"
        >
          <img
            src={require("../../assets/pink-left-arrow.png")}
            alt=""
            aria-hidden="true"
            className="coachmark-step-four-next-icon"
          />
        </button>
      </div>
    </div>
  );
};

export default CoachMarkStepFour;
